import { RoutePath } from '@/routes/enum';
import { CustomRouteObject } from '@/types/type';
import { lazy } from 'react';
import { Navigate } from 'react-router';

const Dashboard = lazy(() => import('./index'));
const RenderParent = lazy(() => import('./render-parent'));
const RenderChild = lazy(() => import('./render-child'));
const NoAuth = lazy(() => import('./no-auth'));
const Private = lazy(() => import('./private-report'));
// const dashboardRoutes = []
const dashboardRoutes: CustomRouteObject[] = [
  {
    path: RoutePath.DASHBOARD,
    name: '驾驶舱',
    checkAuth: false,
    exact: true,
    element: <Dashboard />,
    children: [
      {
        path: RoutePath.DASHBOARD,
        name: '驾驶舱',
        checkAuth: false,
        exact: true,
        hidden: true,
        element: <Navigate to={`${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_NO_AUTH}`} />,
      },
      {
        path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_HOME}`,
        name: '全公司',
        checkAuth: true,
        hidden: false,
        element: <RenderChild />,
      },
      {
        path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_HOME_PERSONAL}`,
        name: '全公司',
        checkAuth: true,
        hidden: false,
        element: <RenderChild />,
      },
      {
        path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}`,
        name: '初心者',
        checkAuth: false,
        hidden: false,
        element: <RenderParent />,
        children: [
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ALL}`,
            name: '合计',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ALL_PERSONAL}`,
            name: '合计',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ROO}`,
            name: 'ROO',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ROO_PERSONAL}`,
            name: 'ROO',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },

          // {
          //   path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ROW}`,
          //   name: 'ROW',
          //   checkAuth: true,
          //   // hidden: true,
          //   element: <RenderChild />
          // },
          // {
          //   path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ROW_PERSONAL}`,
          //   name: 'ROW',
          //   checkAuth: true,
          //   hidden: false,
          //   element: <RenderChild />
          // },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_RO3}`,
            name: 'RO3',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_RO3_PERSONAL}`,
            name: 'RO3',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ROOC}`,
            name: 'ROOC',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_RO}${RoutePath.DASHBOARD_RO_ROOC_PERSONAL}`,
            name: 'ROOC',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
        ],
      },

      {
        path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}`,
        name: '天元',
        checkAuth: false,
        hidden: false,
        element: <RenderParent />,
        children: [
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_ALL}`,
            name: '合计',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_ALL_PERSONAL}`,
            name: '合计',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_ACT}`,
            name: 'ACT',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_ACT_PERSONAL}`,
            name: 'ACT',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_JJSG}`,
            name: '街机三国',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_JJSG_PERSONAL}`,
            name: '街机三国',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_MS}`,
            name: '美食页游',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
          {
            path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_TY}${RoutePath.DASHBOARD_TY_MS_PERSONAL}`,
            name: '美食页游',
            checkAuth: true,
            hidden: false,
            element: <RenderChild />,
          },
        ],
      },
      {
        path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_KOF}`,
        name: '拳皇',
        checkAuth: true,
        hidden: false,
        element: <RenderChild />,
      },
      {
        path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_KOF_PERSONAL}`,
        name: '拳皇',
        checkAuth: true,
        hidden: false,
        element: <RenderChild />,
      },
      {
        path: `${RoutePath.DASHBOARD}${RoutePath.DASHBOARD_PRIVATE}`,
        name: '个人',
        checkAuth: false,
        hidden: false,
        element: <Private />,
      },
      // 匹配无权限时的跳转
      {
        path: `${RoutePath.DASHBOARD}/*`,
        name: '无权限',
        checkAuth: false,
        hidden: true,
        element: <NoAuth />,
      },
    ],
  },
];

export default dashboardRoutes;
